import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/app_pages',
  component: Management,
  redirect: '/app_pages/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/app_pages/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listAppPages
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/app_pages/ListTable'),
          meta: {
            auth: Auth.listAppPages,
            tabName: 'all'
          }
        }
      ]
    }
  ]
}
